import type { DataTableColumnDef } from 'components/data-table';
import { blanksLast } from 'components/data-table';
import type { PerforationGroupRow } from './perforations-grouping';

// One row per completion (UWI14 + Completion #); expand to see its
// perforation intervals (see perforations.tsx's renderRowSubComponent).
export const perforationGroupColumns: DataTableColumnDef<PerforationGroupRow>[] =
  [
    {
      id: 'uwi14Completion',
      accessorKey: 'uwi14Completion',
      header: 'UWI14',
      size: 200,
      meta: { type: 'text' },
    },
    {
      id: 'completionObsNo',
      accessorKey: 'completionObsNo',
      header: 'Completion #',
      size: 140,
      meta: { type: 'integer', align: 'left' },
    },
    {
      // A completion with no date sorts last whichever way the column sorts.
      ...blanksLast<PerforationGroupRow>('completionDate'),
      header: 'Completion Date',
      size: 150,
      meta: { type: 'date' },
    },
    {
      id: 'maxStageNum',
      accessorKey: 'maxStageNum',
      header: 'Stages',
      size: 110,
      meta: { type: 'integer', align: 'left' },
    },
    {
      id: 'intervalCount',
      accessorKey: 'intervalCount',
      header: 'Perforation Intervals',
      size: 180,
      meta: { type: 'integer', align: 'left' },
    },
    {
      id: 'minTopDepthFt',
      accessorKey: 'minTopDepthFt',
      header: 'Top Completion MD (ft)',
      size: 170,
      meta: { type: 'decimal', align: 'left' },
    },
    {
      id: 'maxBaseDepthFt',
      accessorKey: 'maxBaseDepthFt',
      header: 'Bottom Completion MD (ft)',
      size: 170,
      meta: { type: 'decimal', align: 'left' },
    },
  ];
